document.addEventListener("DOMContentLoaded", () => {
const menuContainer = document.getElementById("nav-drawer__container");
const submenuToggles = document.querySelectorAll(".nav-drawer__submenu-toggle");
const backButton = document.querySelector(".nav-drawer__back-to-menu");
const drawerLogo = document.querySelector(".drawer__title");
const menuTitle = document.querySelector('.drawer__menu-title');
const secondaryMenu = document.querySelector('.nav-drawer__menu-secondary');


const updateContainerHeight = (menu) => {
    const height = menu.scrollHeight;
    menuContainer.style.height = `${height}px`;
};

const resizeObserver = new ResizeObserver(() => {
    updateContainerHeight(document.querySelector(".nav-drawer__level.active"));
});
resizeObserver.observe(menuContainer);


submenuToggles.forEach(toggle => {
    toggle.addEventListener("click", (e) => {
    const target = document.getElementById(e.currentTarget.dataset.target);
    const currentMenu = e.currentTarget.dataset.menuTitle;
        
    document.querySelector(".nav-drawer__level.active").classList.remove("active");
    drawerLogo?.classList.remove("active");
    target.classList.add("active");
    backButton.classList.add("active");
    updateContainerHeight(target);
    menuTitle.classList.remove('hidden');
    menuTitle.textContent = currentMenu;
    });
});

backButton.addEventListener("click", (e) => {
    const target = document.getElementById(e.currentTarget.dataset.target);

    document.querySelector(".nav-drawer__level.active").classList.remove("active");
    backButton.classList.remove("active");
    drawerLogo?.classList.add("active");
    target.classList.add("active");
    menuTitle.classList.add('hidden');
    setTimeout(() => {
        updateContainerHeight(target);
    }, 100);
    });
});